// extracted by mini-css-extract-plugin
export default {"image":"style_image__wm-7J","card":"style_card__TgdjH","heading":"style_heading__6UOXH","subtext":"style_subtext__Ubfc7"};